import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-101 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm font-bold text-gray-600"
}
const _hoisted_9 = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-101",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                                        'mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10',
                                        _ctx.variant === 'info' ? 'bg-royal-blue-100' : 'bg-red-100'
                                    ])
                          }, [
                            (_ctx.variant === 'info')
                              ? (_openBlock(), _createBlock(_component_InformationCircleIcon, {
                                  key: 0,
                                  class: "size-6 text-royal-blue-600",
                                  "aria-hidden": "true"
                                }))
                              : (_openBlock(), _createBlock(_component_ExclamationTriangleIcon, {
                                  key: 1,
                                  class: "size-6 text-red-600",
                                  "aria-hidden": "true"
                                }))
                          ], 2),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-base font-semibold text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.title), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.message), 1),
                              (_ctx.secondMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.secondMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "mb-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mb-0 sm:w-auto cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"])),
                          ref: "cancelButtonRef"
                        }, _toDisplayString(_ctx.$t('common.cancel')), 513),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass([
                                        'inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs sm:mr-3 sm:w-auto cursor-pointer',
                                        _ctx.variant === 'info' ? 'bg-royal-blue-600 hover:bg-royal-blue-500' : 'bg-red-600 hover:bg-red-500'
                                    ]),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)), ["stop","prevent"]))
                        }, _toDisplayString(_ctx.buttonText), 3)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}